export const initData = {
    dollar_saved: "0.00",
    fuel_saved: "0.00",
    oil_saved: "0.00",
    reduction_in_co2: "0.00"
}